// store.js

import { configureStore } from "@reduxjs/toolkit";
import customerReducer from "./customerSlice";
import ordersReducer from "./ordersSlice";

const store = configureStore({
  reducer: {
    customer: customerReducer,
    orders: ordersReducer,
  },
});

export default store;
